import { IconButton, Stack, Typography } from "@mui/material";
import { makeStyles } from "components/providers/makeStyles";
import { JerseyAvatar } from "components/layout/heat/JerseyAvatar";
import { Delete } from "@mui/icons-material";
import { TeamMemberRoleMenu } from "./TeamMemberRoleMenu";

const useStyles = makeStyles((theme) => ({
    avatar: {
        justifySelf: "center"
    }
}));

export const TeamMembersAthlete = ({ index, athlete, teamRoleName, teamRoles, assignedRoles, disabled, onAthleteRemoved, onUpdateTeamMemberRole }) => {
    const classes = useStyles();

    return (
        <>
            <JerseyAvatar className={classes.avatar} src={athlete.image} alt={athlete.name}/>
            <Stack pt={1} pb={1} spacing={.5}>
                <Typography variant="subtitle3">{athlete.name}</Typography>
                <TeamMemberRoleMenu selectedTeamRole={teamRoleName} teamRoles={teamRoles} assignedRoles={assignedRoles} disabled={disabled} onUpdateTeamMemberRole={onUpdateTeamMemberRole(index)} />
            </Stack>
            {onAthleteRemoved && <IconButton color="inherit" onClick={onAthleteRemoved(index)}><Delete /></IconButton>}
        </>
    );
};
